module.exports = __webpack_public_path__ + "static/media/pin-map.b588ef49.png";